import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { checkStatus } from '../utilities/fetch';
import { taggingsPath } from '../utilities/api_relative_paths';
import { createQueryString } from '../utilities/utilities';
import AddToFolderTool from './add_to_folder_tool.jsx';
import AddToCuratedListTool from './add_to_curated_list_tool';
import AddNoteTool from './add_note_tool.jsx';

const RecruiterToolsBelt = ({ id, name, notes, manageCuratedLists, curatedCandidateLists }) => {
  const [consultantInFolderTags, setConsultantInFolderTags] = useState([]);
  const [currentNumberOfTags, setCurrentNumberOfTags] = useState(null);
  const [isAddToFolderExpanded, setIsAddToFolderExpanded] = useState(false);
  const [isAddToCuratedList, setIsAddToCuratedList] = useState(false);
  const [currentCuratedCandidateLists, setCurrentCuratedCandidateLists] =
    useState(curatedCandidateLists);

  const new_message_path = '/messages/new';

  const queryParams = {
    recipient_ids: [id],
    recipient_names: [name],
    return_to: window.location.pathname,
  };

  const contactHref = `${new_message_path}${createQueryString(queryParams)}`;

  /**
   * Perform request to fetch all tags for viewed consultant.
   *
   * @returns {undefined}
   */
  const fetchConsultantInFolderTags = () => {
    const taggingsParams = {
      filter: {
        taggable_ids: [id],
        taggable_type: 'Consultant',
      },
      page: { size: 100 },
    };

    fetch(`${taggingsPath}${createQueryString(taggingsParams)}`)
      .then(checkStatus)
      .then((response) => response.json())
      .then((parsedData) => {
        setCurrentNumberOfTags(parsedData.total);
        setConsultantInFolderTags(parsedData.data);
      });
  };

  useEffect(() => {
    fetchConsultantInFolderTags();
  }, []);

  const renderAddToFolderTool = () => {
    if (isAddToFolderExpanded) {
      return (
        <AddToFolderTool
          currentNumberOfTags={currentNumberOfTags}
          setCurrentNumberOfTags={setCurrentNumberOfTags}
          consultantInFolderTags={consultantInFolderTags}
          setConsultantInFolderTags={setConsultantInFolderTags}
          consultantId={id}
        ></AddToFolderTool>
      );
    }
  };

  const renderAddToCuratedCandidateList = () => {
    if (!manageCuratedLists || !isAddToCuratedList) return null;
    return (
      <AddToCuratedListTool
        consultantId={id}
        consultantInCCLs={currentCuratedCandidateLists}
        setConsultantInCCLs={setCurrentCuratedCandidateLists}
      />
    );
  };

  const displayAddToCuratedListButton = manageCuratedLists && (
    <a
      onClick={() => {
        setIsAddToFolderExpanded(false);
        setIsAddToCuratedList(!isAddToCuratedList);
      }}
      aria-controls='add-to-curated-candidate-list-collapse'
      aria-expanded={isAddToCuratedList}
      className={`btn btn-line-default btn-icon-mobile btn-add-folder ${
        isAddToCuratedList && 'active'
      }`}
    >
      <i className='fal icon-folder-plus text-blue'></i>
      <span className='small text-blue'>Add to curated candidate list</span>
      <span className='badge badge-sm folders-count margin-left-small'>
        {currentCuratedCandidateLists.length}
      </span>
    </a>
  );

  return (
    <div className='container'>
      <div className='actions clearfix'>
        <span className='title pull-left text-gray-li'>Recruiter Tools</span>
        <div className='pull-left'>
          <div className='btn-group'>
            <a href={contactHref} className='btn btn-line-default btn-icon-mobile'>
              <i className='fal icon-envelope text-orange-devex'></i>
              <span className='small text-orange-devex strong'>Contact</span>
            </a>
            {displayAddToCuratedListButton}
            <a
              onClick={() => {
                setIsAddToCuratedList(false);
                setIsAddToFolderExpanded(!isAddToFolderExpanded);
              }}
              aria-controls='add-to-folder-collapse'
              aria-expanded={isAddToFolderExpanded}
              className={`btn btn-line-default btn-icon-mobile btn-add-folder ${
                isAddToFolderExpanded && 'active'
              }`}
            >
              <i className='fal icon-folder-open text-blue'></i>
              <span className='small text-blue'>Add to folder</span>
              <span className='badge badge-sm folders-count margin-left-small'>
                {currentNumberOfTags}
              </span>
            </a>
            <AddNoteTool notes={notes}></AddNoteTool>
          </div>
        </div>
        {renderAddToFolderTool()}
        {renderAddToCuratedCandidateList()}
      </div>
    </div>
  );
};

RecruiterToolsBelt.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  notes: PropTypes.array.isRequired,
  manageCuratedLists: PropTypes.bool,
  curatedCandidateLists: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      published: PropTypes.bool.isRequired,
    })
  ),
};

export default RecruiterToolsBelt;
